function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { I as IMaskMixin, _ as _objectWithoutProperties } from "./mixin-9a4bc4a3.js";
import React from 'react';
import 'prop-types';
import 'imask/esm/imask';
var _excluded = ["inputRef"];

var InputComponent = function InputComponent(_ref) {
  var inputRef = _ref.inputRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement('input', _extends({}, props, {
    ref: inputRef
  }));
};

var IMaskInput = IMaskMixin(InputComponent);
export { IMaskInput as default };